"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJsonWithAccountId = exports.isJsonResponse = exports.sendFormData = exports.postJsonWithAccountId = exports.putJson = exports.postJson = exports.patchJson = exports.getJson = exports.deleteJson = exports.fetchJson = exports.onFetchComplete = exports.csrfTokenReady = void 0;
var lodash_1 = __importDefault(require("lodash"));
var url_utils_1 = require("@zapier/url-utils");
var cookies_1 = require("@zapier/cookies");
var NetworkError_1 = __importDefault(require("./NetworkError"));
var fetchSuccess = function (response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    return response.text().then(function (body) {
        // Hack to make legacy z.useful.errors work for now.
        response.responseText = body;
        throw response;
    });
};
// If the client doesn't already have a CSRF token, then retrieve one
var retrieveCsrfToken = function (crossOrigin) {
    if (crossOrigin) {
        return (fetch(process.env.ZAPIER_API_BASE_URL + "/api/v3/csrf", {
            credentials: 'include',
            mode: 'cors',
        })
            .then(fetchSuccess)
            // The `fetch` call can reject with a `TypeError` or `AbortError`, but `fetchSuccess`
            // can reject with the actual response instead of an error (*flips table*). It's too
            // late to change this because of all the downstream dependencies on this behavior, so
            // we're going to have to live with it.
            .catch(function (errorOrResponse) {
            throw new NetworkError_1.default(__assign(__assign({}, errorOrResponse), { message: 'Unable to retrieve CSRF token.' }));
        }));
    }
    return cookies_1.readCookie('csrftoken')
        ? Promise.resolve()
        : fetch('/api/v3/csrf', { credentials: 'same-origin' })
            .then(fetchSuccess)
            // The `fetch` call can reject with a `TypeError` or `AbortError`, but `fetchSuccess`
            // can reject with the actual response instead of an error (*flips table*). It's too
            // late to change this because of all the downstream dependencies on this behavior, so
            // we're going to have to live with it.
            .catch(function (errorOrResponse) {
            throw new NetworkError_1.default(__assign(__assign({}, errorOrResponse), { message: 'Unable to retrieve CSRF token.' }));
        });
};
/**
 * The CSRF token needs to be the first thing retrieved before any CSRF-protected
 * request can take place (e.g. POST requests), so all requests should wait until
 * that resolves before proceeding.
 * To improve performance, we cache the promise from the first call to `csrfTokenReady`.
 */
var _retrieveCsrfTokenPromise = null;
function csrfTokenReady(crossOrigin) {
    if (_retrieveCsrfTokenPromise) {
        return _retrieveCsrfTokenPromise;
    }
    _retrieveCsrfTokenPromise = retrieveCsrfToken(crossOrigin);
    return _retrieveCsrfTokenPromise;
}
exports.csrfTokenReady = csrfTokenReady;
/**
 * Retry trying to get `document.location` if it's not available immediately.
 * We do that because, weirdly, we're seeing some errors in Sentry where `document.location` is `null`.
 * After some initial investigation, it looks like Firefox has a bug where `document.location`
 * is not being properly set until a couple of seconds after the page is loaded.
 */
var waitForLocation = function (totalTimeWaited) {
    if (totalTimeWaited === void 0) { totalTimeWaited = 0; }
    if (document.location) {
        return Promise.resolve(document.location);
    }
    if (totalTimeWaited > 2000) {
        return Promise.reject("Couldn't find document.location after 2 seconds.");
    }
    return new Promise(function (resolve) {
        setTimeout(function () {
            waitForLocation(totalTimeWaited + 100).then(resolve);
        }, 100);
    });
};
/**
 * Test that the base of the request url matches the Zapier API Base URL.
 */
var urlMatchesZapierApiBaseUrl = function (url) {
    if (!process.env.ZAPIER_API_BASE_URL) {
        return false;
    }
    var parsedBaseUrl = new URL(process.env.ZAPIER_API_BASE_URL);
    try {
        var parsedUrl = new URL(url);
        return parsedUrl.origin === parsedBaseUrl.origin;
    }
    catch (err) {
        // the url could have been protocol-relative or relative
        return false;
    }
};
/**
 * Test that a given url is a same-origin URL.
 * url could be relative or scheme relative or absolute host + port.
 */
var sameOrigin = function (url) {
    return waitForLocation().then(function (location) {
        var host = location.host;
        var protocol = location.protocol;
        var sr_origin = '//' + host;
        var origin = protocol + sr_origin;
        /* Allow absolute or scheme relative URLs to same origin
         * or any other URL that isn't scheme relative or absolute i.e relative.
         */
        return (url === origin ||
            url.slice(0, origin.length + 1) === origin + '/' ||
            url === sr_origin ||
            url.slice(0, sr_origin.length + 1) === sr_origin + '/' ||
            !/^(\/\/|http:|https:).*/.test(url));
    });
};
function isRelative(path) {
    return (path.indexOf('//') !== 0 &&
        path.indexOf('https://') !== 0 &&
        path.indexOf('http://') !== 0);
}
/**
 * Checks if the request about to be fired needs an CSRF token.
 * If it does, fetch the token and set it as a request header.
 */
function setCsrfHeaderIfNeeded(url, info) {
    return __awaiter(this, void 0, void 0, function () {
        var method, isCsrfSafeMethod, isSameOrigin, isSafeCrossOrigin, resp, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    method = info.method || '';
                    isCsrfSafeMethod = /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
                    // CSRF-safe methods don't need the CSRF header.
                    if (isCsrfSafeMethod) {
                        return [2 /*return*/, info];
                    }
                    // We currently don't support CSRF for non-browser environments.
                    if (typeof window === 'undefined') {
                        return [2 /*return*/, info];
                    }
                    return [4 /*yield*/, sameOrigin(url)];
                case 1:
                    isSameOrigin = _a.sent();
                    isSafeCrossOrigin = urlMatchesZapierApiBaseUrl(url);
                    if (!isSameOrigin && !isSafeCrossOrigin) {
                        return [2 /*return*/, info];
                    }
                    return [4 /*yield*/, csrfTokenReady(isSafeCrossOrigin)];
                case 2:
                    resp = _a.sent();
                    token = isSafeCrossOrigin
                        ? resp.headers.get('x-upstreamcsrftoken')
                        : cookies_1.readCookie('csrftoken');
                    if (token) {
                        info.headers = new Headers(info.headers || {});
                        info.headers.set('X-CSRFToken', token);
                    }
                    return [2 /*return*/, info];
            }
        });
    });
}
var onFetchCompleteListener = function (_response) { };
// Allow consumers to listen to completed fetch requests.
// This is nasty, but needed to preserve backwards-compatibility with the fetchMiddleware from `@zapier/toolbox-redux-framework`.
function onFetchComplete(fn) {
    onFetchCompleteListener = fn;
}
exports.onFetchComplete = onFetchComplete;
// Note that we don't support passing in `url` `Request` objects, only strings.
var wrappedFetch = function (url, info) {
    if (info === void 0) { info = {}; }
    info = __assign({}, info);
    info.headers = new Headers(info.headers || {});
    info.headers.set('X-Requested-With', 'XMLHttpRequest'); // help django's request.is_ajax()
    info.credentials = 'include';
    // For relative URLs, we let the downstream consumer of the library customize the base URL to prepend
    // via the ZAPIER_API_BASE_URL environment variable.
    var apiUrl = isRelative(url)
        ? "" + (process.env.ZAPIER_API_BASE_URL || '') + url
        : url;
    return setCsrfHeaderIfNeeded(apiUrl, info).then(function (newInfo) {
        return (fetch(apiUrl, newInfo)
            .then(function (response) {
            onFetchCompleteListener(response);
            return response;
        })
            // Our `fetch` call can reject with a `TypeError` or `AbortError`, but `setCsrfHeaderIfNeeded`
            // can reject with the actual response instead of an error (*flips table*). It's too late to
            // change this because of all the downstream dependencies on this behavior, so we're going to
            // have to live with it.
            .catch(function (errorOrResponse) {
            // Sentry captures this error:
            //
            // > We're having some trouble connecting. You might try reloading the page
            // > or checking your internet connection. Only absolute URLs are supported
            //
            // Let's try to include the URL so we can better understand the issue
            var originalMessage = errorOrResponse.message || '';
            var newMessage = originalMessage + " url='" + apiUrl + "'";
            throw new NetworkError_1.default(__assign(__assign({}, errorOrResponse), { message: newMessage }));
        }));
    });
};
wrappedFetch.success = fetchSuccess;
wrappedFetch.json = function (response) {
    return response
        .json()
        .then(function (data) {
        return data;
    })
        .catch(function (err) {
        // Empty content is expected with a 204 and is valid,
        // though parsing it as JSON would fail.
        if (response.status === 204) {
            return null;
        }
        // Throw the error if it was a problem parsing.
        if (response.status >= 200 && response.status < 300) {
            throw err;
        }
        // Otherwise, maybe this was an error status and JSON wasn't expected.
        throw response;
    });
};
// FIXME: This should be a named export instead.
wrappedFetch.url = function (url, params) {
    if (!params) {
        return url;
    }
    var queryString = Object.keys(params).reduce(function (prevQueryString, paramKey) {
        var value = params[paramKey];
        var nextQueryString = prevQueryString;
        if (typeof value !== 'undefined' && value !== null) {
            if (nextQueryString) {
                nextQueryString += '&';
            }
            nextQueryString += encodeURIComponent(paramKey) + "=" + encodeURIComponent(value);
        }
        return nextQueryString;
    }, '');
    return url + (queryString ? '?' : '') + queryString;
};
exports.fetchJson = function (uri, info) {
    info = info ? lodash_1.default.extend({}, info) : {};
    info.headers = new Headers(info.headers || {});
    // It is incorrect to send this with no body and some frameworks,
    // like Aperture's Fastify refuse to process it if we do.
    if (info.body) {
        info.headers.set('Content-Type', 'application/json');
    }
    info.headers.set('Accept', 'application/json');
    return wrappedFetch(uri, info)
        .then(wrappedFetch.success)
        .then(wrappedFetch.json);
};
// `fetchJson` via `method`, passing along a stringified
// `body` if it exists.
var fetchJsonWithMethod = function (method, url, body) {
    return exports.fetchJson(url, __assign(__assign({}, (method !== 'GET' ? { body: body && JSON.stringify(body) } : {})), { method: method }));
};
exports.deleteJson = lodash_1.default.partial(fetchJsonWithMethod, 'DELETE');
exports.getJson = lodash_1.default.partial(fetchJsonWithMethod, 'GET');
exports.patchJson = lodash_1.default.partial(fetchJsonWithMethod, 'PATCH');
exports.postJson = lodash_1.default.partial(fetchJsonWithMethod, 'POST');
exports.putJson = lodash_1.default.partial(fetchJsonWithMethod, 'PUT');
exports.postJsonWithAccountId = function (accountId, url, body) {
    if (body === void 0) { body = {}; }
    return exports.postJson(url, __assign(__assign({}, body), { account_id: accountId }));
};
exports.sendFormData = function (url, formData, opts) {
    if (opts === void 0) { opts = {}; }
    if (opts.headers) {
        opts.headers = new Headers(opts.headers || {});
        opts.headers.set('Accept', 'application/json');
    }
    var options = __assign(__assign({ method: 'POST' }, opts), { body: formData });
    return wrappedFetch(url, options)
        .then(wrappedFetch.success)
        .then(wrappedFetch.json);
};
var isResponseOfType = function (type, response) {
    return lodash_1.default.isFunction(lodash_1.default.get(response, ['headers', 'get'])) &&
        response.headers.get('content-type').indexOf(type) > -1;
};
exports.isJsonResponse = lodash_1.default.partial(isResponseOfType, 'application/json');
exports.getJsonWithAccountId = function (accountId, url) {
    return exports.getJson(url_utils_1.addTruthyParamsToUrl(url, { account_id: accountId }));
};
exports.default = wrappedFetch;
